import { DestroyRef, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter } from 'rxjs/operators';

const VISITED_PATH_KEY = 'visitedPath';
const OIDC_PATH_PREFIX = '/oidc/';

/**
 * Remembers where the visitor is, so the sign-out callback route can send them back. Session storage
 * keeps it per tab, so two tabs on different documents cannot overwrite each other.
 */
export function trackVisitedPath(): void {
  const destroyRef = inject(DestroyRef);

  inject(Router)
    .events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      takeUntilDestroyed(destroyRef)
    )
    .subscribe(({ urlAfterRedirects }) => {
      if (!urlAfterRedirects.startsWith(OIDC_PATH_PREFIX)) {
        rememberVisitedPath(urlAfterRedirects);
      }
    });
}

export function visitedPath(): string | null {
  try {
    return sessionStorage?.getItem(VISITED_PATH_KEY) ?? null;
  } catch (error) {
    console.warn('visited path not restored', error);
    return null;
  }
}

function rememberVisitedPath(path: string): void {
  try {
    sessionStorage?.setItem(VISITED_PATH_KEY, path);
  } catch (error) {
    console.warn('visited path not remembered', error);
  }
}
